import React from "react";
import Services from "../components/Services";
import Contact from "../components/Contact";
import Landing from "../components/Home";
import Reviews from "../components/Reviews";
import Prices from "../components/Prices";
import Credentials from "../components/credentials";
import About from "../components/About";

const Home: React.FC = () => {
  return (
    <>
      <Landing />
      <About />
      <Services />
      <Contact />
      <Reviews />
      <Prices/>
      <Credentials />
    </>
  );
}

export default Home;
